
import { useState, useEffect } from 'react';

import {
  fetchPickAndMix,
  fetchPickAndMixPreview,
} from 'Features/PickAndMix/api/pick-and-mix-service';
import getUrlParameter from 'Helpers/Url/GetUrlParameter';


const useFetchPickAndMix = ({ id, slug }) => {
  const [pickAndMix, setPickAndMix] = useState(null);
  const [notFound, setNotFound] = useState(null);
  const [redirect, setRedirect] = useState(null);

  useEffect(() => {
    setPickAndMix(null);
    setNotFound(null);
    setRedirect(null);

    const handleResult = (result) => {
      if (result.notFound) {
        return setNotFound(true);
      }
      if (result.redirect) {
        return setRedirect(result.redirect);
      }
      return setPickAndMix(result);
    };

    const fetch = async () => {
      const result = await fetchPickAndMix(slug);
      handleResult(result);
    };

    const fetchPreview = async () => {
      const key = getUrlParameter('key') || '';

      const result = await fetchPickAndMixPreview(id, encodeURIComponent(key));
      result.isPreview = true;
      handleResult(result);
    };

    if (id) {
      fetchPreview();
    } else {
      fetch();
    }
  }, [id, slug]);

  return {
    pickAndMix,
    notFound,
    redirect,
  };
};

export default useFetchPickAndMix;
